<template v-if="model && model.newsletterAbos && model.newsletterAbos.count >0">
	<div v-for="abo in model?.newsletterAbos" class="form input-checkbox">
		<input type="checkbox" :name="'Abonniert'+abo.id" :id="'Abonniert'+abo.id" v-model="abo.abonniert" />
		<label :for="'Abonniert'+abo.id">Ja, senden Sie mir den {{abo.name}} unverbindlich zu.</label>
	</div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
var NewsletterAbos = defineComponent({
	name:"NewsletterAbos",
	props:{
		model: {}
	},
});
export default NewsletterAbos;
</script>